export default "__VITE_ASSET__BWM4mdlB__"